import { z } from '@campai/lib-common/utils/zod'
import { type RouterInput } from '@campai/lib-web/utils/trpc'

type TopicSort = RouterInput['product']['community']['topics']['listTopics']['sort']

export const topicSortOptions = [
    'newestTopics',
    'oldestTopics',
    'mostReplies',
    'leastReplies',
    'newestReply',
    'oldestReply',
] as const

export type TopicSortOption = (typeof topicSortOptions)[number]

export const SearchSchema = z.object({
    page: z.number().int().positive().optional().default(1),
    searchTerm: z.string().optional(),
    sort: z.enum(topicSortOptions).optional().default('newestTopics'),
})

export type Search = z.infer<typeof SearchSchema>

export const pageSize = 30

export const isTopicSortOption = (value: unknown): value is TopicSortOption => {
    return topicSortOptions.some((sortOption) => sortOption === value)
}

export const getTopicSort = (sortOption: TopicSortOption): TopicSort => {
    switch (sortOption) {
        case 'oldestTopics':
            return { pinnedAt: 'desc', createdAt: 'asc' }
        case 'mostReplies':
            return { pinnedAt: 'desc', postsCount: 'desc', latestActivityAt: 'desc', createdAt: 'desc' }
        case 'leastReplies':
            return { pinnedAt: 'desc', postsCount: 'asc', latestActivityAt: 'desc', createdAt: 'desc' }
        case 'newestReply':
            return { pinnedAt: 'desc', latestActivityAt: 'desc', createdAt: 'desc' }
        case 'oldestReply':
            return { pinnedAt: 'desc', latestActivityAt: 'asc', createdAt: 'asc' }
        case 'newestTopics':
            return { pinnedAt: 'desc', createdAt: 'desc' }
    }
}
